import { Type } from 'class-transformer';

import { ApiProperty } from '../../codegen';
import {
  IsBoolean,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from '../../validators';
import { TAchievementId } from '../achievements/achievements.registry';

import { EDailyRewardSlotStatus, EDailyRewardType } from './daily-reward.enums';

export class DailyRewardSlotDto {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  dayIndex: number;

  @ApiProperty()
  @IsEnum(EDailyRewardSlotStatus, { groups: ['error'] })
  status: EDailyRewardSlotStatus;

  @ApiProperty()
  @IsOptional()
  @IsEnum(EDailyRewardType, { groups: ['error'] })
  rewardType?: EDailyRewardType;

  @ApiProperty()
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  coins?: number;

  @ApiProperty()
  @IsOptional()
  @IsString({ groups: ['error'] })
  achievementId?: TAchievementId;
}

export class DailyRewardStateDto {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  currentDayIndex: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  currentStreak: number;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  openedToday: boolean;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  canOpen: boolean;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  maxDayIndex: number;

  @ApiProperty()
  @ValidateNested({ each: true })
  @Type(() => DailyRewardSlotDto)
  slots: DailyRewardSlotDto[];
}

export class DailyRewardOpenResultDto {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  dayIndex: number;

  @ApiProperty()
  @IsEnum(EDailyRewardType, { groups: ['error'] })
  rewardType: EDailyRewardType;

  @ApiProperty()
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  coins?: number;

  @ApiProperty()
  @IsOptional()
  @IsString({ groups: ['error'] })
  achievementId?: TAchievementId;
}
